<style scoped>
.monitor-detail {
  position: relative;
  height: calc(100vh - 60px);
  overflow: hidden;
}
.header-bar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(255,255,255,0.92);
  padding: 8px 15px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
}
.header-bar .stage-selector {
  display: flex;
  align-items: center;
  gap: 10px;
}
.main-body {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}
.map-section {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.map-tools {
  position: absolute;
  top: 55px;
  right: 10px;
  z-index: 10;
  background: rgba(255,255,255,0.95);
  padding: 10px;
  border-radius: 4px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.1);
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 140px;
  max-height: calc(100vh - 160px);
  overflow-y: auto;
}
.map-tools .tool-title {
  font-size: 12px;
  color: #606266;
  font-weight: bold;
  border-bottom: 1px solid #ebeef5;
  padding-bottom: 6px;
  margin-bottom: 2px;
}
.map-tools .tool-row {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}
.data-section {
  position: absolute;
  bottom: 10px;
  left: 10px;
  right: 10px;
  height: auto;
  max-height: 38%;
  z-index: 10;
  display: flex;
  gap: 10px;
  background: rgba(255,255,255,0.95);
  border-radius: 4px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.1);
  padding: 10px;
  overflow: hidden;
}
.data-section.collapsed {
  max-height: 36px;
  padding: 6px 10px;
  overflow: hidden;
  justify-content: center;
  align-items: center;
}
.data-section-toggle {
  position: absolute;
  top: 6px;
  right: 10px;
  font-size: 13px;
  color: #606266;
  cursor: pointer;
  user-select: none;
  z-index: 11;
  padding: 2px 8px;
}
.data-section-toggle:hover {
  color: #409eff;
}
.data-section.collapsed .data-section-toggle {
  position: static;
  width: 100%;
  text-align: center;
  font-size: 13px;
  padding: 4px 0;
}
.data-left {
  width: 55%;
  min-height: 0;
  overflow-y: auto;
  padding-bottom: 40px;
}
.data-right {
  width: 45%;
  min-height: 0;
  overflow-y: auto;
  padding-bottom: 40px;
}
.info-row {
  margin-bottom: 8px;
  font-size: 13px;
}
.info-label {
  color: #606266;
  display: inline-block;
  width: 100px;
  text-align: right;
  margin-right: 8px;
}
.info-value {
  color: #303133;
  font-weight: 500;
}
.data-form {
  margin-top: 6px;
  padding-top: 6px;
  border-top: 1px dashed #dcdfe6;
}
.resource-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
}
.resource-item:last-child {
  border-bottom: none;
}
.resource-info {
  flex: 1;
  overflow: hidden;
}
.resource-name {
  font-size: 13px;
  color: #303133;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.resource-meta {
  font-size: 11px;
  color: #909399;
  margin-top: 2px;
}
.resource-section-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 13px;
  font-weight: bold;
  margin-bottom: 8px;
  color: #303133;
  cursor: pointer;
  user-select: none;
  padding: 4px 0;
}
.resource-section-title:hover {
  color: #409eff;
}
.coverage-result {
  background: #f0f9ff;
  border: 1px solid #b3d8ff;
  border-radius: 4px;
  padding: 6px 10px;
  margin-top: 6px;
}
.coverage-result .value {
  font-size: 20px;
  color: #409eff;
  font-weight: bold;
}
.coverage-result .label {
  font-size: 12px;
  color: #606266;
}
.context-menu {
  position: absolute;
  background: #fff;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.15);
  z-index: 30;
  min-width: 100px;
  padding: 4px 0;
}
.context-item {
  padding: 8px 16px;
  font-size: 13px;
  color: #606266;
  cursor: pointer;
}
.context-item:hover {
  background: #f5f7fa;
}
.context-delete {
  color: #f56c6c;
}
</style>

<template>
  <div class="manage-section monitor-detail">
    <div class="header-bar">
      <div class="current-title">监测任务详情</div>
      <div class="stage-selector">
        <el-select v-model="currentStageId" placeholder="请选择阶段" @change="onStageChange" style="width: 280px;" disabled>
          <el-option
            v-for="s in stageList"
            :key="s.id"
            :label="s.label"
            :value="s.id"
          />
        </el-select>
      </div>
    </div>

    <div class="main-body">
      <!-- 地图 -->
      <div class="map-section">
        <swqyun-map
          ref="map"
          style="width: 100%; height: 100%;"
          :scene-url="sceneUrl"
          :session-key="sessionKey"
          :app-id="appId"
          :editable="mapEditable"
          :draw-type.sync="drawType"
          :vectors="mapVectors"
          :markers="mapMarkers"
          :auto-fly="true"
          scene="task"
          @draw-complete="onDrawComplete"
          @vector-click="onVectorClick"
          @marker-click="onMarkerClick"
          @object-right-click="onObjectRightClick"
          @map-click="onMapClick"
          @map-right-click="onMapRightClick"
          @map-error="onMapError"
          @scene-load-timeout="onSceneLoadTimeout"
        />
        <!-- 右键菜单 -->
        <div
          v-if="contextMenuVisible"
          class="context-menu"
          :style="{ top: contextMenuTop + 'px', left: contextMenuLeft + 'px' }"
        >
          <div v-if="contextMenuTarget && contextMenuTarget.type === 'marker'">
            <div class="context-item" @click="handleViewResource">查看</div>
            <div class="context-item context-delete" @click="handleDeleteResource">删除</div>
          </div>
          <div v-if="contextMenuTarget && contextMenuTarget.type === 'vector'">
            <div class="context-item context-delete" @click="handleDeleteVector">删除矢量</div>
          </div>

        </div>

        <!-- 地图浮动工具栏 -->
        <div class="map-tools">
          <div class="tool-title">{{ mapEditable ? "编辑中" : "工具栏" }}</div>


          <!-- 矢量编辑：危岩体稳定性 / 变形监测 / 复绿植被成活率 / 植被覆盖率监测 -->
          <template v-if="canDrawVector">
            <div class="tool-row">
              <el-button :type="mapEditable ? 'warning' : 'primary'" size="mini" @click="toggleEditMap">
                {{ mapEditable ? "完成编辑" : "编辑矢量" }}
              </el-button>
            </div>
            <template v-if="mapEditable">
              <div class="tool-row">
                <el-radio-group v-model="drawType" size="mini">
                  <template v-if="monitorType !== '植被覆盖率监测'">
                    <el-radio-button label="point">点</el-radio-button>
                    <el-radio-button label="line">线</el-radio-button>
                  </template>
                  <el-radio-button label="area">面</el-radio-button>
                </el-radio-group>
              </div>
              <div v-if="monitorType === '植被覆盖率监测'" class="tool-row">
                <el-alert
                  title="请画出植被未覆盖的区域，可画多个"
                  type="warning"
                  :closable="false"
                  show-icon
                  style="padding: 4px 8px; width: 100%;"
                />
              </div>
              <div class="tool-row">
                <el-button size="mini" icon="el-icon-delete" @click="clearVectors">清除</el-button>
              </div>
            </template>
          </template>

          <!-- 植被网格：植被监测 -->
          <template v-if="isVegetationGridType">
            <div class="tool-title" style="margin-top:6px;border-top:1px solid #ebeef5;padding-top:6px;">植被网格</div>
            <div class="tool-row">
              <el-select v-model="gridSize" size="mini" style="width: 90px;" placeholder="网格尺寸">
                <el-option label="1x1m" value="1" />
                <el-option label="3x3m" value="3" />
                <el-option label="10x10m" value="10" />
              </el-select>
              <el-button size="mini" :type="gridPickingMode ? 'warning' : 'primary'" @click="generateGrid">{{ gridPickingMode ? '取消选点' : '生成网格' }}</el-button>
            </div>
            <div class="tool-row">
              <el-button size="mini" @click="importKml">导入KML</el-button>
              <el-button size="mini" type="danger" @click="clearAllGrids">清除所有网格</el-button>
            </div>
          </template>

          <!-- 拍照点：除植被覆盖率外部分类型 -->
          <template v-if="canAddPhoto">
            <div class="tool-title" style="margin-top:6px;border-top:1px solid #ebeef5;padding-top:6px;">拍照点</div>
            <div class="tool-row">
              <el-button size="mini" type="primary" @click="startAddPhoto">
                <i class="el-icon-camera"></i> 添加
              </el-button>
            </div>
          </template>

          <!-- 表格上传：危岩体稳定性 / 变形监测 / 复绿植被成活率 / 植被监测 -->
          <template v-if="canUploadTable">
            <div class="tool-title" style="margin-top:6px;border-top:1px solid #ebeef5;padding-top:6px;">表格</div>
            <div class="tool-row">
              <el-button size="mini" type="primary" @click="openUploadDialog('TABLE')">上传表格</el-button>
            </div>
          </template>

          <!-- 报告上传：土壤监测 / 水样监测 -->
          <template v-if="canUploadReport">
            <div class="tool-title" style="margin-top:6px;border-top:1px solid #ebeef5;padding-top:6px;">报告</div>
            <div class="tool-row">
              <el-button size="mini" type="primary" @click="openUploadDialog('REPORT')">上传报告</el-button>
            </div>
          </template>

          <!-- 复绿植被成活率趋势 -->
          <template v-if="monitorType === '复绿植被成活率监测'">
            <div class="tool-title" style="margin-top:6px;border-top:1px solid #ebeef5;padding-top:6px;">趋势</div>
            <div class="tool-row">
              <el-button size="mini" type="success" @click="showTrend">查看趋势</el-button>
            </div>
          </template>
        </div>
      </div>

      <!-- 数据面板 -->
      <div class="data-section" :class="{ collapsed: bottomPanelCollapsed }">
        <div class="data-section-toggle" @click="bottomPanelCollapsed = !bottomPanelCollapsed">
          <span v-if="bottomPanelCollapsed"><i class="el-icon-arrow-up"></i> 展开任务信息</span>
          <span v-else><i class="el-icon-arrow-down"></i> 收起</span>
        </div>
        <div v-show="!bottomPanelCollapsed" class="data-left">
          <el-card :body-style="{ padding: '10px 15px 40px 15px' }">
            <div slot="header">
              <span>任务信息</span>
            </div>
            <div class="info-row">
              <span class="info-label">监测类型：</span>
              <span class="info-value">{{ taskInfo.monitorType || "-" }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">年份：</span>
              <span class="info-value">{{ taskInfo.year || "-" }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">乡镇/街道：</span>
              <span class="info-value">{{ taskInfo.township || "-" }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">阶段状态：</span>
              <span class="info-value">
                <el-tag v-if="currentStage" :type="currentStage.status == 1 ? 'success' : 'warning'" size="mini">
                  {{ currentStage.status == 1 ? "已完结" : "进行中" }}
                </el-tag>
                <span v-else>-</span>
              </span>
            </div>
            <div class="info-row">
              <span class="info-label">图斑面积：</span>
              <span class="info-value">{{ (taskInfo.area || 0).toLocaleString() }} m²</span>
            </div>

            <!-- 类型特定数据表单 -->
            <div class="data-form">
              <div v-if="monitorType === '复绿植被成活率监测'">
                <div class="info-row" style="display: flex; gap: 16px;">
                  <div>
                    <span class="info-label">植被成活率：</span>
                    <el-input-number v-model="monitorData.vegetationSurvivalRate" :min="0" :max="100" size="mini" style="width: 100px;" />
                    <span style="margin-left: 4px; color: #909399;">%</span>
                  </div>
                  <div>
                    <span class="info-label">植被成活数：</span>
                    <el-input-number v-model="monitorData.vegetationSurvivalCount" :min="0" :precision="0" size="mini" style="width: 100px;" />
                    <span style="margin-left: 4px; color: #909399;">株</span>
                  </div>
                </div>
                <div class="info-row" v-if="repairArea > 0">
                  <span class="info-label">修复面积：</span>
                  <span class="info-value">{{ repairArea.toFixed(2) }} m²</span>
                </div>
              </div>

              <div v-if="monitorType === '土壤监测'">
                <div class="info-row">
                  <span class="info-label">土壤质量达标率：</span>
                  <el-input-number v-model="monitorData.soilQualityRate" :min="0" :max="100" size="mini" style="width: 120px;" />
                  <span style="margin-left: 4px; color: #909399;">%</span>
                </div>
              </div>

              <div v-if="monitorType === '水样监测'">
                <div class="info-row">
                  <span class="info-label">水质达标率：</span>
                  <el-input-number v-model="monitorData.waterQualityRate" :min="0" :max="100" size="mini" style="width: 120px;" />
                  <span style="margin-left: 4px; color: #909399;">%</span>
                </div>
              </div>

              <div v-if="monitorType === '植被覆盖率监测'">
                <div class="coverage-result">
                  <div style="display: flex; align-items: center; gap: 10px; flex-wrap: wrap;">
                    <span class="label" style="white-space: nowrap;">植被覆盖率</span>
                    <span class="value" style="font-size: 16px;">{{ monitorData.vegetationCoverage != null ? Number(monitorData.vegetationCoverage).toFixed(2) : '--' }}%</span>
                    <div style="display: flex; align-items: center; gap: 4px; margin-left: auto;">
                      <el-input-number v-model="monitorData.vegetationCoverage" :min="0" :max="100" :precision="2" size="mini" style="width: 140px;" />
                      <span style="color: #909399; font-size: 12px;">%</span>
                      <el-button v-if="coverageCalculated" size="mini" type="text" @click="useCalculatedCoverage">使用计算值</el-button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 保存数据按钮 -->
              <div v-if="!mapEditable && hasDataChanges" style="margin-top: 12px; text-align: right;">
                <el-button size="mini" type="primary" icon="el-icon-check" @click="saveAllData">保存数据</el-button>
              </div>
            </div>
          </el-card>
        </div>

        <div v-show="!bottomPanelCollapsed" class="data-right">
          <el-card :body-style="{ padding: '10px 15px' }">
            <div slot="header">
              <span>资源列表</span>
            </div>

            <!-- 照片 -->
            <div v-if="canAddPhoto">
              <div class="resource-section-title" @click="resourceCollapsed.photo = !resourceCollapsed.photo">
                <span>拍照点 <el-tag size="mini" type="info">{{ photoGroups.length }}个</el-tag> <el-tag size="mini" type="warning">{{ photoResources.length }}张</el-tag></span>
                <i :class="resourceCollapsed.photo ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
              </div>
              <div v-show="!resourceCollapsed.photo">
                <div v-if="photoGroups.length === 0" style="color: #909399; font-size: 12px; padding: 8px 0;">暂无拍照点</div>
                <div v-for="(group, gIdx) in photoGroups" :key="group.key" class="resource-item">
                  <div class="resource-info">
                    <div class="resource-name">拍照点{{ gIdx + 1 }}</div>
                    <div class="resource-meta">{{ formatCoord(group.longitude, group.latitude) }} · {{ group.validCount }}张照片</div>
                  </div>
                  <div>
                    <el-button size="mini" type="text" @click="openPhotoAlbum(group)">查看</el-button>
                    <el-button size="mini" type="text" @click="openPhotoEdit(group)">修改</el-button>
                    <el-button size="mini" type="text" style="color: #f56c6c;" @click="deletePhotoGroup(group)">删除</el-button>
                  </div>
                </div>
              </div>
            </div>

            <!-- 表格 -->
            <div v-if="canUploadTable || canUploadReport" style="margin-top: 12px;">
              <div class="resource-section-title" @click="resourceCollapsed.table = !resourceCollapsed.table">
                <span>表格文件 <el-button size="mini" type="text" @click.stop="openUploadDialog('TABLE')">上传</el-button></span>
                <i :class="resourceCollapsed.table ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
              </div>
              <div v-show="!resourceCollapsed.table">
                <div v-if="tableResources.length === 0" style="color: #909399; font-size: 12px; padding: 8px 0;">暂无表格文件</div>
                <div v-for="item in tableResources" :key="item.id" class="resource-item">
                <div class="resource-info">
                  <div class="resource-name">{{ item.name || "表格" }}</div>
                  <div class="resource-meta">{{ item.createTime ? item.createTime.substring(0, 16) : "" }}</div>
                </div>
                <div>
                  <el-button size="mini" type="text" @click="previewResource(item)">查看</el-button>
                  <el-button size="mini" type="text" @click="downloadResource(item)">下载</el-button>
                  <el-button size="mini" type="text" style="color: #f56c6c;" @click="deleteResource(item)">删除</el-button>
                </div>
              </div>
              </div>
            </div>

            <!-- 报告 -->
            <div v-if="canUploadReport" style="margin-top: 12px;">
              <div class="resource-section-title" @click="resourceCollapsed.report = !resourceCollapsed.report">
                <span>报告文件 <el-button size="mini" type="text" @click.stop="openUploadDialog('REPORT')">上传</el-button></span>
                <i :class="resourceCollapsed.report ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
              </div>
              <div v-show="!resourceCollapsed.report">
                <div v-if="reportResources.length === 0" style="color: #909399; font-size: 12px; padding: 8px 0;">暂无报告文件</div>
                <div v-for="item in reportResources" :key="item.id" class="resource-item">
                <div class="resource-info">
                  <div class="resource-name">{{ item.name || "报告" }}</div>
                  <div class="resource-meta">{{ item.createTime ? item.createTime.substring(0, 16) : "" }}</div>
                </div>
                <div>
                  <el-button size="mini" type="text" @click="downloadResource(item)">下载</el-button>
                  <el-button size="mini" type="text" style="color: #f56c6c;" @click="deleteResource(item)">删除</el-button>
                </div>
              </div>
              </div>
            </div>
          </el-card>
        </div>
      </div>
    </div>

    <!-- 添加阶段对话框 -->
    <el-dialog title="添加阶段" :visible.sync="addStageVisible" width="350px">
      <el-form label-width="80px">
        <el-form-item label="阶段序号">
          <el-input-number v-model="newStageOrder" :min="1" :max="10" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="addStageVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmAddStage">确定</el-button>
      </span>
    </el-dialog>

    <!-- 照片上传对话框 -->
    <el-dialog title="上传照片" :visible.sync="photoDialogVisible" width="400px">
      <el-form label-width="80px">
        <el-form-item label="位置">
          <span v-if="pendingPhotoPoint">{{ formatCoord(pendingPhotoPoint.lon, pendingPhotoPoint.lat) }}</span>
          <span v-else style="color: #909399;">未选择位置</span>
        </el-form-item>
        <el-form-item label="照片">
          <div style="margin-bottom: 8px; color: #909399; font-size: 12px;">
            该拍照点最多可上传2张照片，当前已上传 {{ getPhotoCountAt(pendingPhotoPoint ? pendingPhotoPoint.lon : 0, pendingPhotoPoint ? pendingPhotoPoint.lat : 0) }} 张
          </div>
          <el-upload
            ref="photoUpload"
            action=""
            :auto-upload="false"
            :limit="2"
            multiple
            :on-change="handlePhotoFilesChange"
            :on-remove="handlePhotoFilesRemove"
          >
            <el-button size="small" type="primary">选择照片</el-button>
            <div slot="tip" class="el-upload__tip">最多选择2张照片，当前已选 {{ photoUploadFiles.length }} 张</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="photoDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmPhotoUpload">上传</el-button>
      </span>
    </el-dialog>

    <!-- 文件上传对话框（表格/报告） -->
    <el-dialog :title="uploadDialogTitle" :visible.sync="fileDialogVisible" width="400px">
      <el-form label-width="80px">
        <el-form-item label="文件">
          <div v-if="fileUploadType === 'TABLE'" style="margin-bottom: 8px; color: #e6a23c; font-size: 12px;">
            <i class="el-icon-warning-outline"></i> 请上传填写表格的拍照照片
          </div>
          <el-upload
            ref="fileUpload"
            action=""
            :auto-upload="false"
            :limit="1"
            :on-change="handleFileChange"
            :on-remove="() => { fileUploadFile = null; }"
          >
            <el-button size="small" type="primary">选择文件</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="fileDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmFileUpload">上传</el-button>
      </span>
    </el-dialog>

    <!-- 图片预览（单张） -->
    <el-dialog :visible.sync="previewVisible" title="预览">
      <img :src="previewUrl" style="max-width: 100%; display: block; margin: 0 auto;" />
    </el-dialog>

    <!-- 照片相册（轮播） -->
    <el-dialog :visible.sync="photoAlbumVisible" title="照片预览" width="600px">
      <el-carousel v-if="albumPhotos.length > 0" :interval="5000" arrow="always" height="400px">
        <el-carousel-item v-for="(photo, idx) in albumPhotos" :key="photo.id">
          <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100%;">
            <img :src="getFileUrl(photo.url)" style="max-width: 100%; max-height: 340px; object-fit: contain;" />
            <div style="text-align: center; margin-top: 8px; color: #606266; font-size: 13px;">{{ photo.name }} ({{ idx + 1 }} / {{ albumPhotos.length }})</div>
          </div>
        </el-carousel-item>
      </el-carousel>
      <div v-else style="text-align: center; color: #909399; padding: 20px;">暂无照片</div>
    </el-dialog>

    <!-- 拍照点编辑 -->
    <el-dialog :visible.sync="photoEditVisible" title="拍照点编辑" width="500px">
      <div v-if="photoEditGroup">
        <div style="margin-bottom: 12px; color: #606266; font-size: 13px;">
          坐标：{{ formatCoord(photoEditGroup.longitude, photoEditGroup.latitude) }}
        </div>
        <div v-if="!photoEditGroup.photos.some(p => p.url && String(p.url).trim() !== '')" style="color: #909399; font-size: 12px; padding: 10px 0;">暂无照片</div>
        <div style="display: flex; gap: 12px; flex-wrap: wrap;">
          <div v-for="photo in photoEditGroup.photos.filter(p => p.url && String(p.url).trim() !== '')" :key="photo.id" style="position: relative; width: 120px;">
            <img :src="getFileUrl(photo.url)" style="width: 120px; height: 120px; object-fit: cover; border-radius: 4px; cursor: pointer; border: 1px solid #ebeef5;" @click="previewResource(photo)" />
            <div style="font-size: 11px; color: #606266; margin-top: 4px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{ photo.name }}</div>
            <el-button size="mini" type="danger" icon="el-icon-delete" circle style="position: absolute; top: -8px; right: -8px;" @click="deletePhotoInEdit(photo)" />
          </div>
        </div>
        <div v-if="photoEditGroup.photos.filter(p => p.url && String(p.url).trim() !== '').length < 2" style="margin-top: 16px;">
          <el-upload
            ref="photoEditUpload"
            action=""
            :auto-upload="false"
            :limit="2"
            multiple
            :on-change="handlePhotoEditFilesChange"
            :on-remove="handlePhotoEditFilesRemove"
          >
            <el-button size="small" type="primary">上传照片</el-button>
            <div slot="tip" class="el-upload__tip">该拍照点最多2张照片，当前 {{ photoEditGroup.photos.filter(p => p.url && String(p.url).trim() !== '').length }} 张，已选 {{ photoEditUploadFiles.length }} 张</div>
          </el-upload>
        </div>
        <div v-else style="margin-top: 12px; color: #909399; font-size: 12px;">该拍照点已满2张照片，如需更换请先删除旧照片</div>
      </div>
      <span slot="footer">
        <el-button @click="photoEditVisible = false">关闭</el-button>
        <el-button v-if="photoEditUploadFiles.length > 0" type="primary" @click="confirmPhotoEditUpload">上传</el-button>
      </span>
    </el-dialog>

    <!-- 趋势图 -->
    <el-dialog :visible.sync="trendVisible" title="复绿植被成活率趋势" width="600px">
      <div ref="trendChart" style="width: 100%; height: 350px;"></div>
    </el-dialog>
  </div>
</template>

<script>
import SwqyunMap from "@/components/SwqyunMap.vue";
import polygonClipping from "polygon-clipping";
import config from "@/utils/config.js";

export default {
  components: { SwqyunMap },
  data() {
    return {
      taskId: null,
      taskInfo: {},
      spotId: null,

      // 阶段
      stageList: [],
      currentStageId: null,
      currentStage: null,

      // 地图配置
      sceneUrl: "",
      sessionKey: "",
      appId: "",

      // 地图编辑
      mapEditable: false,
      drawType: "point",
      bottomPanelCollapsed: false,
      taskVectors: [], // 当前任务的矢量 {type, coordinates, id}

      // 资源
      stageResources: [],
      mapMarkers: [], // 地图上显示的资源标记点

      // 右键菜单
      contextMenuVisible: false,
      contextMenuTop: 0,
      contextMenuLeft: 0,
      contextMenuTarget: null, // {type, data}

      // 趋势图
      trendVisible: false,
      trendData: [],

      // 监测数据
      monitorData: {
        vegetationCoverage: null,
        vegetationSurvivalRate: null,
        vegetationSurvivalCount: null,
        soilQualityRate: null,
        waterQualityRate: null,
        repairArea: null
      },
      originalMonitorData: null,

      // 照片上传
      photoDialogVisible: false,
      photoUploadFiles: [],
      pendingPhotoPoint: null,
      addingPhoto: false,

      // 资源列表展开收起
      resourceCollapsed: {
        photo: false,
        table: false,
        report: false
      },

      // 文件上传
      fileDialogVisible: false,
      fileUploadType: "",
      fileUploadFile: null,

      // 添加阶段
      addStageVisible: false,
      newStageOrder: 1,

      // 预览
      previewVisible: false,
      previewUrl: "",

      // 照片相册
      photoAlbumVisible: false,
      albumPhotos: [],

      // 拍照点编辑
      photoEditVisible: false,
      photoEditGroup: null,
      photoEditUploadFiles: [],

      // 网格尺寸
      gridSize: "3",
      // 网格选点模式
      gridPickingMode: false,

      isAdmin: false,
      spotVectors: [] // 图斑本身的矢量范围
    };
  },
  computed: {
    monitorType() {
      return this.taskInfo.monitorType || "";
    },
    canAddPhoto() {
      return ["危岩体稳定性监测", "变形监测", "复绿植被成活率监测", "土壤监测", "水样监测", "植被覆盖率监测", "植被监测"].includes(this.monitorType);
    },
    isVegetationGridType() {
      return ["植被监测"].includes(this.monitorType);
    },
    isCoverageType() {
      return this.monitorType === "植被覆盖率监测";
    },
    isVectorType() {
      return ["危岩体稳定性监测", "变形监测", "复绿植被成活率监测"].includes(this.monitorType);
    },
    canDrawVector() {
      return ["危岩体稳定性监测", "变形监测", "复绿植被成活率监测", "植被覆盖率监测"].includes(this.monitorType);
    },
    canUploadTable() {
      return ["危岩体稳定性监测", "变形监测", "复绿植被成活率监测", "植被监测", "土壤监测", "植被覆盖率监测", "水样监测"].includes(this.monitorType);
    },
    canUploadReport() {
      return ["土壤监测", "水样监测"].includes(this.monitorType);
    },
    mapVectors() {
      return [
        ...this.toMapVectors(this.spotVectors, "spot"),
        ...this.toMapVectors(this.taskVectors, "task")
      ];
    },
    photoResources() {
      return this.stageResources.filter(r => r.type === "PHOTO");
    },
    tableResources() {
      return this.stageResources.filter(r => r.type === "TABLE");
    },
    reportResources() {
      return this.stageResources.filter(r => r.type === "REPORT");
    },
    photoCount() {
      return this.photoResources.length;
    },
    photoGroups() {
      const groups = {};
      this.photoResources.forEach(r => {
        const key = `${parseFloat(r.longitude).toFixed(6)},${parseFloat(r.latitude).toFixed(6)}`;
        if (!groups[key]) {
          groups[key] = {
            key,
            longitude: r.longitude,
            latitude: r.latitude,
            photos: []
          };
        }
        groups[key].photos.push(r);
      });
      Object.values(groups).forEach(g => {
        g.validCount = g.photos.filter(p => p.url && String(p.url).trim() !== '').length;
      });
      return Object.values(groups);
    },
    repairArea() {
      // 从面矢量计算面积
      let area = 0;
      this.taskVectors.forEach(v => {
        if (v.type === "area" && v.area) {
          area += v.area;
        }
      });
      return area;
    },
    coveragePercent() {
      if (!this.isCoverageType) return 0;
      // 获取图斑边界多边形
      const spotPolys = this.spotVectors.filter(v => v.type === "area").map(v => v.coordinates);
      const uncoveredPolys = this.taskVectors
        .filter(v => v.type === "area" && v.area)
        .map(v => v.coordinates);

      let uncoveredArea = 0;
      if (spotPolys.length > 0 && uncoveredPolys.length > 0) {
        // 先计算所有未覆盖区域的并集，再与图斑边界求交集，避免重叠区域重复计算
        try {
          const originLon = uncoveredPolys[0][0][0];
          const originLat = uncoveredPolys[0][0][1];
          const R = 6371000;
          const cosLat = Math.cos(originLat);
          const toLocal = (poly) => poly.map(p => [
            (p[0] - originLon) * R * cosLat,
            (p[1] - originLat) * R
          ]);
          const closePoly = (poly) => {
            if (!poly || poly.length === 0) return poly;
            const first = poly[0];
            const last = poly[poly.length - 1];
            if (first[0] !== last[0] || first[1] !== last[1]) {
              return [...poly, first];
            }
            return poly;
          };

          // 计算所有未覆盖区域的并集
          let unionPolys = [toLocal(closePoly(uncoveredPolys[0]))];
          for (let i = 1; i < uncoveredPolys.length; i++) {
            const next = toLocal(closePoly(uncoveredPolys[i]));
            unionPolys = polygonClipping.union(unionPolys, next);
            // union 返回 MultiPolygon，需要归一化为 Polygon 格式以便继续合并
            if (Array.isArray(unionPolys) && unionPolys.length > 0 && Array.isArray(unionPolys[0]) && Array.isArray(unionPolys[0][0])) {
              // 已经是 MultiPolygon 格式 [[ring], [ring], ...]
            } else {
              unionPolys = [unionPolys];
            }
          }

          // 与图斑边界求交集
          let totalIntersectArea = 0;
          spotPolys.forEach(spotPoly => {
            const spotLocal = toLocal(closePoly(spotPoly));
            const intersections = polygonClipping.intersection(unionPolys, spotLocal);
            if (intersections && intersections.length > 0) {
              intersections.forEach(intersectPoly => {
                const coords = intersectPoly[0]; // 外环
                if (!coords || coords.length < 3) return;
                let area = 0;
                for (let i = 0; i < coords.length - 1; i++) {
                  area += coords[i][0] * coords[i + 1][1] - coords[i + 1][0] * coords[i][1];
                }
                totalIntersectArea += Math.abs(area) * 0.5;
              });
            }
          });
          uncoveredArea = totalIntersectArea;
        } catch (e) {
          console.error("[coveragePercent] union/intersection error:", e);
          // fallback: 逐个与图斑边界求交集后相加
          uncoveredPolys.forEach(poly => {
            spotPolys.forEach(spotPoly => {
              uncoveredArea += this.calcIntersectionArea(poly, spotPoly);
            });
          });
        }
      } else if (uncoveredPolys.length > 0) {
        // 没有图斑边界，简单相加（不考虑重叠）
        uncoveredPolys.forEach(poly => {
          uncoveredArea += this.calcPolygonArea(poly);
        });
      }

      if (uncoveredArea <= 0) return this.monitorData.vegetationCoverage || 100;

      // 优先使用图斑面积，若明显不合理（与矢量面积或包围盒面积相差 10 倍以上）则用矢量面积兜底
      let spotArea = this.taskInfo.area;
      const vectorSpotArea = this.calcSpotAreaFromVectors();
      const bbox = this.getSpotBbox();
      let bboxArea = 0;
      if (bbox) {
        const centerLat = (bbox.minLat + bbox.maxLat) / 2;
        const R = 6371000;
        bboxArea = (bbox.maxLon - bbox.minLon) * (R * Math.cos(centerLat)) * (bbox.maxLat - bbox.minLat) * R;
      }
      const isAreaUnreasonable = !spotArea || spotArea <= 0
        || (vectorSpotArea > 0 && spotArea < vectorSpotArea * 0.1)
        || (bboxArea > 0 && spotArea < bboxArea * 0.1);
      if (isAreaUnreasonable) {
        console.log("[coveragePercent] taskInfo.area", spotArea, "unreasonable, vectorArea:", vectorSpotArea, "bboxArea:", bboxArea);
        spotArea = vectorSpotArea > 0 ? vectorSpotArea : (bboxArea > 0 ? bboxArea : 10000);
      }
      if (!spotArea || spotArea <= 0) spotArea = 10000;
      const uncoveredPercent = Math.min(100, (uncoveredArea / spotArea) * 100);
      const percent = Math.max(0, 100 - uncoveredPercent);
      console.log("[coveragePercent] uncoveredArea:", uncoveredArea, "spotArea:", spotArea, "uncovered%:", uncoveredPercent, "coverage%:", percent);
      return percent.toFixed(2);
    },
    coverageCalculated() {
      return this.isCoverageType && this.repairArea > 0;
    },
    uploadDialogTitle() {
      if (this.fileUploadType === "TABLE") return "上传表格文件";
      if (this.fileUploadType === "REPORT") return "上传报告文件";
      return "上传文件";
    },
    hasDataChanges() {
      if (!this.originalMonitorData) return false;
      const keys = ["vegetationCoverage", "vegetationSurvivalRate", "vegetationSurvivalCount", "soilQualityRate", "waterQualityRate", "repairArea"];
      return keys.some(k => {
        const a = this.monitorData[k] != null ? Number(this.monitorData[k]) : null;
        const b = this.originalMonitorData[k] != null ? Number(this.originalMonitorData[k]) : null;
        return a !== b;
      });
    }
  },
  created() {
    this.taskId = this.$route.query.id;
    this.spotId = this.$route.query.spotId ? parseInt(this.$route.query.spotId) : null;
    this.checkAdmin();
    this.loadMapConfig();
    this.getDetail();
  },
  watch: {
    "$route.query.id"(newId, oldId) {
      if (newId && newId !== oldId) {
        this.taskId = newId;
        this.spotId = this.$route.query.spotId ? parseInt(this.$route.query.spotId) : null;
        this.resetPageData();
        this.getDetail();
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      [300, 800, 1500, 2500].forEach(ms => {
        setTimeout(() => {
          if (this.$refs.map && this.$refs.map.doResize) {
            this.$refs.map.doResize();
          }
        }, ms);
      });
    });
  },
  methods: {
    checkAdmin() {
      try {
        const user = JSON.parse(localStorage.getItem("adminUser") || "{}");
        const roles = user.roleCodeList || [];
        this.isAdmin = roles.includes("SUPER_ADMIN") || roles.includes("ADMIN");
      } catch (e) {
        this.isAdmin = false;
      }
    },
    loadMapConfig() {
      const districtInfo = this.$store.state.district && this.$store.state.district.districtInfo;
      const districtId = districtInfo ? districtInfo.districtId : null;
      this.$apis.get("/admin/districtMapConfig/detail", { districtId }).then(res => {
        // 如果当前页面已经通过 stage 加载了地图配置，则不再覆盖
        if (this.sceneUrl && this.sceneUrl !== this.getDefaultSceneUrl()) {
          return;
        }
        if (res && res.data && res.data.code == 200 && res.data.data) {
          const cfg = res.data.data;
          this.sceneUrl = cfg.sceneUrl;
          this.sessionKey = cfg.sessionKey;
          this.appId = cfg.appId;
          console.log("[spotMonitorDetail] loadMapConfig success:", cfg);
        } else {
          console.log("[spotMonitorDetail] loadMapConfig empty, using default");
          this.setDefaultMap();
        }
      }).catch(err => {
        console.error("[spotMonitorDetail] loadMapConfig error:", err);
        if (!this.sceneUrl || this.sceneUrl === this.getDefaultSceneUrl()) {
          this.setDefaultMap();
        }
      });
    },
    getDefaultSceneUrl() {
      return "https://api.swqyun.com/api/fileManage/Scene/SDKGetScene?id=138b92545134d878d5d90ca45490263c";
    },
    setDefaultMap() {
      this.sceneUrl = "https://api.swqyun.com/api/fileManage/Scene/SDKGetScene?id=138b92545134d878d5d90ca45490263c";
      this.sessionKey = "0271ae43f09e427cb6927d6255446bc0b3cec903f45b48a49fb22dba752f52cb";
      this.appId = "31f37381eb434c2b";
    },
    resetPageData() {
      this.taskInfo = {};
      this.stageList = [];
      this.currentStageId = null;
      this.currentStage = null;
      this.taskVectors = [];
      this.stageResources = [];
      this.mapMarkers = [];
      this.monitorData = {
        vegetationCoverage: null,
        vegetationSurvivalRate: null,
        vegetationSurvivalCount: null,
        soilQualityRate: null,
        waterQualityRate: null,
        repairArea: null
      };
      this.originalMonitorData = null;
      this.sessionKey = "";
      this.appId = "";
      this.sceneUrl = "";
      this.spotVectors = [];
      this.chartData = [];
      this.trendData = [];
      this.photoGroups = [];
      this.resourceCollapsed = { photo: false, table: false, report: false };
    },
    getDetail() {
      console.log("[spotMonitorDetail] getDetail taskId=", this.taskId);
      this.$apis.get("/admin/spotTask/detail/" + this.taskId).then(res => {
        console.log("[spotMonitorDetail] getDetail response:", res && res.data);
        if (res && res.data && res.data.code == 200) {
          this.taskInfo = res.data.data || {};
          console.log("[spotMonitorDetail] taskInfo assigned:", this.taskInfo);
          // 加载任务自身的矢量数据
          this.taskVectors = this.parseVectorGeoJson(this.taskInfo.vectorGeoJson);
          console.log("[spotMonitorDetail] taskVectors loaded:", this.taskVectors);
          if (this.taskInfo.spotId) {
            this.spotId = this.taskInfo.spotId;
          }
          if (this.spotId) {
            this.loadStages();
          }
        }
      }).catch(err => {
        console.error("[spotMonitorDetail] getDetail error:", err);
      });
    },
    loadStages() {
      console.log("[spotMonitorDetail] loadStages spotId=", this.spotId);
      this.$apis.get("/admin/spot/stage/list", { spotId: this.spotId }).then(res => {
        console.log("[spotMonitorDetail] loadStages response:", res.data);
        if (res.data.code == 200) {
          this.stageList = res.data.data || [];
          // 自动选择第一个未完结的阶段，或第一个阶段
          if (this.stageList.length > 0) {
            const unfinished = this.stageList.find(s => s.status != 1);
            this.currentStageId = unfinished ? unfinished.id : this.stageList[0].id;
            this.onStageChange(this.currentStageId);
          }
        }
      });
      // 加载图斑本身的矢量范围
      this.loadSpotVector();
    },
    loadSpotVector() {
      if (!this.spotId) return;
      this.$apis.get("/admin/spot/page", { pageIndex: 1, pageSize: 1000 }).then(res => {
        if (res.data.code == 200 && res.data.data && res.data.data.list) {
          const spot = res.data.data.list.find(item => item.id === this.spotId);
          if (spot && spot.vectorGeoJson) {
            this.spotVectors = this.parseVectorGeoJson(spot.vectorGeoJson);
            console.log("[spotMonitorDetail] spotVectors loaded:", this.spotVectors);
          } else {
            this.spotVectors = [];
          }
        }
      });
    },
    onStageChange(stageId) {
      console.log("[spotMonitorDetail] onStageChange stageId=", stageId);
      this.mapEditable = false;
      this.currentStageId = stageId;
      this.currentStage = this.stageList.find(s => s.id === stageId) || null;
      this.loadStageDetail(stageId);
    },
    loadStageDetail(stageId) {
      console.log("[spotMonitorDetail] loadStageDetail stageId=", stageId, "taskId=", this.taskId);
      const params = { stageId };
      if (this.taskId) params.taskId = this.taskId;
      this.$apis.get("/admin/spot/stage/detail", params).then(res => {
        console.log("[spotMonitorDetail] loadStageDetail response:", res.data);
        if (res.data.code == 200) {
          const data = res.data.data || {};
          // 切换正射影像（先同步 sessionKey/appId，再在下个 tick 更新 sceneUrl，避免 SwqyunMap 的 sceneUrl watcher 读到旧认证信息）
          if (data.map2dSceneUrl) {
            this.sessionKey = data.map2dSessionKey || this.sessionKey;
            this.appId = data.map2dAppId || this.appId;
            this.$nextTick(() => {
              this.sceneUrl = data.map2dSceneUrl;
              console.log("[spotMonitorDetail] map config updated:", { sceneUrl: this.sceneUrl, sessionKey: this.sessionKey, appId: this.appId });
            });
          }
          // 阶段矢量不再直接加载到任务（任务矢量单独存储）
          // this.taskVectors = this.parseVectorGeoJson(data.vectorGeoJson);

          // 资源
          this.stageResources = data.resources || [];
          // 计算每个坐标点的照片数量
          const photoCountMap = {};
          (data.resources || []).forEach(r => {
            if (r.type === 'PHOTO' && r.longitude != null && r.latitude != null) {
              const key = `${parseFloat(r.longitude).toFixed(6)},${parseFloat(r.latitude).toFixed(6)}`;
              photoCountMap[key] = (photoCountMap[key] || 0) + 1;
            }
          });
          // 给每个拍照点坐标分配序号
          const photoIndexMap = {};
          let photoIndexCounter = 1;
          (data.resources || []).forEach(r => {
            if (r.type === 'PHOTO' && r.longitude != null && r.latitude != null) {
              const key = `${parseFloat(r.longitude).toFixed(6)},${parseFloat(r.latitude).toFixed(6)}`;
              if (!photoIndexMap[key]) {
                photoIndexMap[key] = photoIndexCounter++;
              }
            }
          });
          // 资源转地图 marker（排除已在矢量中显示的 PHOTO/TABLE/REPORT）
          this.mapMarkers = (data.resources || [])
            .filter(r => r.longitude != null && r.latitude != null)
            .map(r => {
              let photoCount = 0;
              let photoIndex = 0;
              if (r.type === 'PHOTO') {
                const key = `${parseFloat(r.longitude).toFixed(6)},${parseFloat(r.latitude).toFixed(6)}`;
                photoCount = photoCountMap[key] || 0;
                photoIndex = photoIndexMap[key] || 0;
              }
              return {
                id: r.id,
                type: r.type,
                name: r.type === 'PHOTO' && photoIndex > 0 ? `拍照点${photoIndex}` : (r.name || r.type),
                longitude: r.longitude,
                latitude: r.latitude,
                url: r.url,
                photoCount,
                photoIndex
              };
            });
          console.log("[spotMonitorDetail] mapMarkers:", this.mapMarkers);

          // 监测数据
          if (data.vegetationCoverage != null) {
            this.monitorData.vegetationCoverage = Number(data.vegetationCoverage);
          }
          this.monitorData.vegetationSurvivalRate = data.vegetationSurvivalRate != null ? Number(data.vegetationSurvivalRate) : this.monitorData.vegetationSurvivalRate;
          this.monitorData.vegetationSurvivalCount = data.vegetationSurvivalCount != null ? Number(data.vegetationSurvivalCount) : this.monitorData.vegetationSurvivalCount;
          this.monitorData.soilQualityRate = data.soilQualityRate != null ? Number(data.soilQualityRate) : this.monitorData.soilQualityRate;
          this.monitorData.waterQualityRate = data.waterQualityRate != null ? Number(data.waterQualityRate) : this.monitorData.waterQualityRate;
          this.monitorData.repairArea = data.repairArea != null ? Number(data.repairArea) : this.monitorData.repairArea;
          this.originalMonitorData = JSON.parse(JSON.stringify(this.monitorData));
        }
      });
    },

    // GeoJSON 解析（兼容标准 GeoJSON FeatureCollection 和前端原始格式 {calcType, pointList}）
    parseVectorGeoJson(geoJsonStr) {
      if (!geoJsonStr) return [];
      try {
        const geo = JSON.parse(geoJsonStr);
        if (!geo) return [];
        // 兼容前端原始格式 {calcType, pointList}
        if (geo.calcType && Array.isArray(geo.pointList)) {
          const type = geo.calcType === "point" ? "point" : (geo.calcType === "line" ? "line" : "area");
          if (type === "point" && geo.pointList.length > 0) {
            return [{ id: "sv_0", type: "point", coordinates: [parseFloat(geo.pointList[0].longitude), parseFloat(geo.pointList[0].latitude)] }];
          } else if (type === "line") {
            return [{ id: "sv_0", type: "line", coordinates: geo.pointList.map(p => [parseFloat(p.longitude), parseFloat(p.latitude)]) }];
          } else if (type === "area") {
            const coords = geo.pointList.map(p => [parseFloat(p.longitude), parseFloat(p.latitude)]);
            return [{ id: "sv_0", type: "area", coordinates: coords, area: this.calcPolygonArea(coords) }];
          }
          return [];
        }
        // 标准 GeoJSON FeatureCollection
        if (!geo.features) return [];
        return geo.features.map((f, idx) => {
          const type = f.geometry.type;
          if (type === "Point") {
            return { id: (f.properties && f.properties.id) || "p" + idx, type: "point", coordinates: f.geometry.coordinates };
          } else if (type === "LineString") {
            return { id: (f.properties && f.properties.id) || "l" + idx, type: "line", coordinates: f.geometry.coordinates };
          } else if (type === "Polygon") {
            const coords = f.geometry.coordinates[0];
            let area = (f.properties && f.properties.area) || 0;
            if (!area || area <= 0) {
              area = this.calcPolygonArea(coords);
            }
            return { id: (f.properties && f.properties.id) || "a" + idx, type: "area", coordinates: coords, area };
          }
          return null;
        }).filter(Boolean);
      } catch (e) {
        return [];
      }
    },
    vectorsToGeoJson(vectors) {
      const features = vectors.map(v => {
        if (v.type === "point") {
          return { type: "Feature", geometry: { type: "Point", coordinates: v.coordinates }, properties: { id: v.id } };
        } else if (v.type === "line") {
          return { type: "Feature", geometry: { type: "LineString", coordinates: v.coordinates }, properties: { id: v.id } };
        } else if (v.type === "area") {
          return { type: "Feature", geometry: { type: "Polygon", coordinates: [v.coordinates] }, properties: { id: v.id, area: v.area || 0 } };
        }
        return null;
      }).filter(Boolean);
      return { type: "FeatureCollection", features };
    },
    toMapVectors(vectors, source) {
      if (!vectors || vectors.length === 0) return [];
      return vectors.map(v => {
        let item = null;
        if (v.type === "point") {
          item = {
            calcType: "point",
            id: v.id,
            pointList: [{ latitude: v.coordinates[1], longitude: v.coordinates[0], height: 0, imageList: [] }]
          };
        } else if (v.type === "line") {
          item = {
            calcType: "line",
            id: v.id,
            pointList: v.coordinates.map(c => ({ latitude: c[1], longitude: c[0], height: 0, imageList: [] }))
          };
        } else if (v.type === "area") {
          item = {
            calcType: "area",
            id: v.id,
            pointList: v.coordinates.map(c => ({ latitude: c[1], longitude: c[0], height: 0, imageList: [] }))
          };
        }
        if (item && source) item.source = source;
        return item;
      }).filter(Boolean);
    },
    fromMapVector(vec) {
      if (!vec || !vec.pointList || vec.pointList.length === 0) return null;
      const id = "v" + Date.now() + Math.random().toString(36).substr(2, 5);
      if (vec.calcType === "point") {
        const p = vec.pointList[0];
        return { id, type: "point", coordinates: [parseFloat(p.longitude), parseFloat(p.latitude)] };
      } else if (vec.calcType === "line") {
        return { id, type: "line", coordinates: vec.pointList.map(p => [parseFloat(p.longitude), parseFloat(p.latitude)]) };
      } else if (vec.calcType === "area") {
        const coords = vec.pointList.map(p => [parseFloat(p.longitude), parseFloat(p.latitude)]);
        // 计算面积（简化：使用 Shoelace formula）
        const area = this.calcPolygonArea(coords);
        return { id, type: "area", coordinates: coords, area };
      }
      return null;
    },
    calcPolygonArea(coords) {
      // 将弧度坐标转为局部平面坐标（米），再用 Shoelace 公式计算面积
      const n = coords.length;
      if (n < 3) return 0;

      const originLon = coords[0][0];
      const originLat = coords[0][1];
      const R = 6371000;
      const cosLat = Math.cos(originLat);

      // 局部平面坐标：以第一个点为原点（米）
      const local = coords.map(c => [
        (c[0] - originLon) * R * cosLat,
        (c[1] - originLat) * R
      ]);

      let area = 0;
      for (let i = 0; i < n - 1; i++) {
        area += local[i][0] * local[i + 1][1] - local[i + 1][0] * local[i][1];
      }
      area = Math.abs(area) * 0.5;
      console.log("[calcPolygonArea] coords count:", n, "origin:", originLon, originLat, "calculatedArea(m2):", area);
      return area;
    },
    // 确保多边形闭合（第一个点等于最后一个点）
    closePolygon(poly) {
      if (!poly || poly.length === 0) return poly;
      const first = poly[0];
      const last = poly[poly.length - 1];
      if (first[0] !== last[0] || first[1] !== last[1]) {
        return [...poly, first];
      }
      return poly;
    },
    // 计算两个多边形交集面积（坐标为弧度）
    calcIntersectionArea(poly1, poly2) {
      if (!poly1 || !poly2 || poly1.length < 3 || poly2.length < 3) return 0;
      try {
        const closed1 = this.closePolygon(poly1);
        const closed2 = this.closePolygon(poly2);
        // 使用 poly1 的第一个点作为局部平面坐标原点
        const originLon = closed1[0][0];
        const originLat = closed1[0][1];
        const R = 6371000;
        const cosLat = Math.cos(originLat);

        const toLocal = (poly) => poly.map(p => [
          (p[0] - originLon) * R * cosLat,
          (p[1] - originLat) * R
        ]);

        const local1 = [toLocal(closed1)];
        const local2 = [toLocal(closed2)];

        const intersections = polygonClipping.intersection(local1, local2);
        if (!intersections || intersections.length === 0) return 0;

        let totalArea = 0;
        intersections.forEach(intersectPoly => {
          const coords = intersectPoly[0]; // 外环
          if (!coords || coords.length < 3) return;
          let area = 0;
          for (let i = 0; i < coords.length - 1; i++) {
            area += coords[i][0] * coords[i + 1][1] - coords[i + 1][0] * coords[i][1];
          }
          totalArea += Math.abs(area) * 0.5;
        });
        return totalArea;
      } catch (e) {
        console.error("[calcIntersectionArea] error:", e);
        return 0;
      }
    },

    // 地图编辑
    toggleEditMap() {
      if (this.mapEditable) {
        // 结束编辑（绘制完成时已在 onDrawComplete 中自动保存，此处不再重复保存）
        this.mapEditable = false;
      } else {
        // 先设置绘制类型，再启用编辑，避免 SwqyunMap 重复调用 startDraw
        if (this.isVectorType || this.isCoverageType) {
          this.drawType = this.isCoverageType ? "area" : "point";
        }
        this.addingPhoto = false;
        this.mapEditable = true;
      }
    },
    onDrawComplete(e) {
      if (this.addingPhoto) {
        // 添加拍照点
        if (e && e.pointList && e.pointList.length > 0) {
          const p = e.pointList[0];
          this.pendingPhotoPoint = { lon: parseFloat(p.longitude), lat: parseFloat(p.latitude) };
          this.photoDialogVisible = true;
        }
        this.addingPhoto = false;
        this.mapEditable = false;
        // 清除 drawPrimitive 创建的临时点，避免 Swqyun 默认大头针图标残留
        this.$nextTick(() => {
          if (this.$refs.map && this.$refs.map.clearDraw) {
            this.$refs.map.clearDraw();
          }
        });
        return;
      }
      // 普通矢量绘制
      console.log("[onDrawComplete] draw-complete event:", e);
      const vec = this.fromMapVector(e);
      console.log("[onDrawComplete] fromMapVector result:", vec);
      if (vec) {
        this.taskVectors.push(vec);
        console.log("[onDrawComplete] taskVectors after push:", this.taskVectors);
        // 自动计算相关指标
        if (vec.type === "area") {
          if (this.isCoverageType) {
            this.monitorData.vegetationCoverage = parseFloat(this.coveragePercent);
          }
          if (this.monitorType === "复绿植被成活率监测") {
            this.monitorData.repairArea = parseFloat(this.repairArea.toFixed(2));
          }
        }
        // 保存矢量
        this.saveVectors();
      }
    },
    clearVectors() {
      this.taskVectors = [];
      this.$refs.map && this.$refs.map.clearDrawVectors && this.$refs.map.clearDrawVectors();
      this.saveVectors();
    },
    saveVectors() {
      if (!this.taskId) return;
      const geoJson = this.vectorsToGeoJson(this.taskVectors);
      console.log("[saveVectors] taskVectors:", this.taskVectors, "geoJson:", geoJson);
      const params = {
        taskId: this.taskId,
        vectorGeoJson: JSON.stringify(geoJson)
      };
      if (this.monitorType === "复绿植被成活率监测" && this.repairArea > 0) {
        params.repairArea = parseFloat(this.repairArea.toFixed(2));
      }
      this.$apis.post("/admin/spotTask/saveVector", params).then(res => {
        if (res.data.code == 200) {
          this.$message.success("矢量数据已保存");
          if (params.repairArea != null) {
            this.originalMonitorData.repairArea = this.monitorData.repairArea;
          }
        }
      });
      // 植被覆盖率保存到阶段级别
      if (this.isCoverageType && this.currentStageId) {
        const coverage = parseFloat(this.coveragePercent);
        this.$apis.post("/admin/spot/stage/data/save", {
          stageId: this.currentStageId,
          vegetationCoverage: coverage
        }).then(res => {
          if (res.data.code == 200) {
            this.monitorData.vegetationCoverage = coverage;
            this.originalMonitorData.vegetationCoverage = coverage;
          }
        });
      }
    },
    onVectorClick(e) {
      console.log("vector click", e);
      if (!e || !e.vector) return;
      const vec = e.vector;
      const type = vec.calcType || "point";
      let info = "";
      if (type === "point") {
        const p = vec.pointList && vec.pointList[0];
        if (p) {
          const lon = (parseFloat(p.longitude) * (180 / Math.PI)).toFixed(6);
          const lat = (parseFloat(p.latitude) * (180 / Math.PI)).toFixed(6);
          info = `经度: ${lon}°, 纬度: ${lat}°`;
        }
      } else if (type === "line") {
        const pts = vec.pointList || [];
        if (pts.length >= 2) {
          let totalLength = 0;
          const R = 6371000;
          for (let i = 0; i < pts.length - 1; i++) {
            const lon1 = parseFloat(pts[i].longitude);
            const lat1 = parseFloat(pts[i].latitude);
            const lon2 = parseFloat(pts[i + 1].longitude);
            const lat2 = parseFloat(pts[i + 1].latitude);
            const dlon = lon2 - lon1;
            const dlat = lat2 - lat1;
            const a = Math.sin(dlat / 2) * Math.sin(dlat / 2) +
                      Math.cos(lat1) * Math.cos(lat2) * Math.sin(dlon / 2) * Math.sin(dlon / 2);
            const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            totalLength += R * c;
          }
          info = `长度: ${totalLength.toFixed(2)} 米`;
        }
      } else if (type === "area") {
        const coords = (vec.pointList || []).map(p => [parseFloat(p.longitude), parseFloat(p.latitude)]);
        if (coords.length >= 3) {
          const area = this.calcPolygonArea(coords);
          info = `面积: ${area.toFixed(2)} 平方米`;
        }
      }
      if (info) {
        this.$message.info({ message: info, duration: 5000 });
      }
    },
    onMarkerClick(marker) {
      if (!marker) return;
      const item = this.stageResources.find(r => r.id === parseInt(marker.id));
      if (!item) return;
      if (item.type === "PHOTO") {
        this.openPhotoAlbum(item);
      } else if (item.type === "TABLE" || item.type === "REPORT") {
        this.previewResource(item);
      }
    },
    onObjectRightClick(picked, screenPos) {
      this.contextMenuVisible = false;
      this.$nextTick(() => {
        if (picked.type === "marker") {
          this.contextMenuTarget = { type: "marker", data: picked.marker };
        } else if (picked.type === "vector") {
          this.contextMenuTarget = { type: "vector", id: picked.id };
        }
        this.contextMenuLeft = screenPos.screenX;
        this.contextMenuTop = screenPos.screenY;
        this.contextMenuVisible = true;
      });
      // 点击其他地方关闭菜单
      const closeMenu = () => {
        this.contextMenuVisible = false;
        document.removeEventListener("click", closeMenu);
      };
      setTimeout(() => document.addEventListener("click", closeMenu), 50);
    },
    handleViewResource() {
      this.contextMenuVisible = false;
      if (!this.contextMenuTarget || this.contextMenuTarget.type !== "marker") return;
      const marker = this.contextMenuTarget.data;
      const item = this.stageResources.find(r => r.id === parseInt(marker.id));
      if (!item) return;
      if (item.type === "PHOTO") {
        this.openPhotoAlbum(item);
      } else {
        this.previewResource(item);
      }
    },
    handleDeleteResource() {
      this.contextMenuVisible = false;
      if (!this.contextMenuTarget || this.contextMenuTarget.type !== "marker") return;
      const marker = this.contextMenuTarget.data;
      this.deleteResource({ id: parseInt(marker.id), type: marker.type });
    },
    handleDeleteVector() {
      this.contextMenuVisible = false;
      if (!this.contextMenuTarget || this.contextMenuTarget.type !== "vector") return;
      const vectorId = this.contextMenuTarget.id;
      if (!vectorId) return;
      const index = this.taskVectors.findIndex(v => v.id === vectorId);
      if (index >= 0) {
        this.taskVectors.splice(index, 1);
        this.saveVectors();
        this.$message.success("矢量已删除");
      }
    },

    onMapRightClick(e) {
      // 右键点击地图空白处，不做特殊操作（已由 object-right-click 处理对象右键）
    },
    onMapError(err) {
      this.$message.error("地图加载失败，请检查地图配置或联系管理员");
      console.error("[spotMonitorDetail] map load error:", err);
    },
    onSceneLoadTimeout() {
      console.warn("[spotMonitorDetail] scene load timeout, fallback to default map");
      this.$message.warning("场景加载超时，尝试使用默认地图");
      this.setDefaultMap();
    },
    showTrend() {
      // 加载所有阶段的 vegetationSurvivalRate，绘制折线图
      const stages = this.stageList || [];
      const data = [];
      let loaded = 0;
      if (stages.length === 0) {
        this.$message.info("暂无阶段数据");
        return;
      }
      stages.forEach(s => {
        this.$apis.get("/admin/spot/stage/detail", { stageId: s.id }).then(res => {
          if (res.data.code == 200) {
            const d = res.data.data || {};
            data.push({
              label: s.label,
              year: s.year,
              stageOrder: s.stageOrder,
              value: d.vegetationSurvivalRate != null ? parseFloat(d.vegetationSurvivalRate) : null
            });
          }
          loaded++;
          if (loaded >= stages.length) {
            data.sort((a, b) => (a.year - b.year) || (a.stageOrder - b.stageOrder));
            this.trendData = data;
            this.trendVisible = true;
            this.$nextTick(() => this.renderTrendChart());
          }
        });
      });
    },
    renderTrendChart() {
      if (!this.$refs.trendChart) return;
      const chart = window.echarts.init(this.$refs.trendChart);
      const option = {
        tooltip: { trigger: "axis" },
        grid: { left: "3%", right: "4%", bottom: "3%", containLabel: true },
        xAxis: { type: "category", data: this.trendData.map(d => d.label) },
        yAxis: { type: "value", name: "成活率(%)" },
        series: [{ data: this.trendData.map(d => d.value), type: "line", smooth: true }]
      };
      chart.setOption(option);
    },

    // 拍照点
    startAddPhoto() {
      this.photoDialogVisible = false;
      this.photoUploadFiles = [];
      this.pendingPhotoPoint = null;
      this.$nextTick(() => {
        this.$refs.photoUpload && this.$refs.photoUpload.clearFiles();
      });
      this.addingPhoto = true;
      this.mapEditable = true;
      this.drawType = "point";
      this.$message.info("请在地图上点击选择拍照点位置");
    },
    getPhotoCountAt(lon, lat) {
      const tolerance = 0.000001;
      return this.photoResources.filter(r =>
        r.url && String(r.url).trim() !== '' &&
        Math.abs(parseFloat(r.longitude) - parseFloat(lon)) < tolerance &&
        Math.abs(parseFloat(r.latitude) - parseFloat(lat)) < tolerance
      ).length;
    },
    addPhotoToExisting(item) {
      if (!item || item.longitude == null || item.latitude == null) return;
      if (this.getPhotoCountAt(item.longitude, item.latitude) >= 2) {
        this.$message.warning("该拍照点最多上传2张照片");
        return;
      }
      this.pendingPhotoPoint = { lon: parseFloat(item.longitude), lat: parseFloat(item.latitude) };
      this.photoUploadFiles = [];
      this.$nextTick(() => {
        this.$refs.photoUpload && this.$refs.photoUpload.clearFiles();
      });
      this.photoDialogVisible = true;
    },
    handlePhotoFilesChange(file, fileList) {
      this.photoUploadFiles = fileList.map(f => f.raw).filter(Boolean);
    },
    handlePhotoFilesRemove(file, fileList) {
      this.photoUploadFiles = fileList.map(f => f.raw).filter(Boolean);
    },
    confirmPhotoUpload() {
      if (!this.photoUploadFiles || this.photoUploadFiles.length === 0) {
        this.$message.error("请选择照片");
        return;
      }
      if (!this.pendingPhotoPoint) {
        this.$message.error("未选择位置");
        return;
      }
      const currentCount = this.getPhotoCountAt(this.pendingPhotoPoint.lon, this.pendingPhotoPoint.lat);
      if (currentCount + this.photoUploadFiles.length > 2) {
        this.$message.warning(`该拍照点最多上传2张照片，当前已有 ${currentCount} 张，本次选择了 ${this.photoUploadFiles.length} 张`);
        return;
      }

      const uploadOne = (file) => {
        const formData = new FormData();
        formData.append("stageId", this.currentStageId);
        if (this.taskId) formData.append("taskId", this.taskId);
        formData.append("type", "PHOTO");
        formData.append("longitude", this.pendingPhotoPoint.lon.toString());
        formData.append("latitude", this.pendingPhotoPoint.lat.toString());
        formData.append("file", file);
        return this.$apis.post("/admin/spot/stage/resource/upload", formData, {
          headers: {}
        });
      };

      Promise.all(this.photoUploadFiles.map(uploadOne))
        .then(results => {
          const allSuccess = results.every(res => res.data.code == 200);
          if (allSuccess) {
            this.$message.success("照片上传成功");
            this.photoDialogVisible = false;
            this.photoUploadFiles = [];
            this.pendingPhotoPoint = null;
            this.$refs.photoUpload && this.$refs.photoUpload.clearFiles();
            this.loadStageDetail(this.currentStageId);
          } else {
            const failed = results.find(res => res.data.code != 200);
            this.$message.error(failed ? (failed.data.msg || "部分照片上传失败") : "上传失败");
          }
        })
        .catch(err => {
          console.error("[confirmPhotoUpload] error:", err);
          this.$message.error("上传失败：" + (err.message || "网络错误，请检查后端服务是否启动"));
        });
    },

    // 文件上传（表格/报告）
    openUploadDialog(type) {
      this.fileUploadType = type;
      this.fileDialogVisible = true;
      this.fileUploadFile = null;
      this.$nextTick(() => {
        this.$refs.fileUpload && this.$refs.fileUpload.clearFiles();
      });
    },
    handleFileChange(file) {
      this.fileUploadFile = file.raw;
    },
    confirmFileUpload() {
      if (!this.fileUploadFile) {
        this.$message.error("请选择文件");
        return;
      }
      const formData = new FormData();
      formData.append("stageId", this.currentStageId);
      if (this.taskId) formData.append("taskId", this.taskId);
      formData.append("type", this.fileUploadType);
      formData.append("file", this.fileUploadFile);

      this.$apis.post("/admin/spot/stage/resource/upload", formData, {
        headers: {}
      }).then(res => {
        if (res.data.code == 200) {
          this.$message.success("上传成功");
          this.fileDialogVisible = false;
          this.fileUploadFile = null;
          this.$refs.fileUpload && this.$refs.fileUpload.clearFiles();
          this.loadStageDetail(this.currentStageId);
        } else {
          this.$message.error(res.data.msg || "上传失败");
        }
      });
    },

    // 资源操作
    previewResource(item) {
      if (item.url) {
        this.previewUrl = this.getFileUrl(item.url);
        this.previewVisible = true;
      }
    },
    openPhotoAlbum(itemOrCoord) {
      let lon, lat;
      if (itemOrCoord.longitude != null && itemOrCoord.latitude != null) {
        lon = itemOrCoord.longitude;
        lat = itemOrCoord.latitude;
      } else if (itemOrCoord.lon != null && itemOrCoord.lat != null) {
        lon = itemOrCoord.lon;
        lat = itemOrCoord.lat;
      } else {
        return;
      }
      const photos = this.photoResources.filter(r =>
        r.url && String(r.url).trim() !== '' &&
        Math.abs(parseFloat(r.longitude) - parseFloat(lon)) < 0.000001 &&
        Math.abs(parseFloat(r.latitude) - parseFloat(lat)) < 0.000001
      );
      if (photos.length === 0) return;
      if (photos.length === 1) {
        this.previewResource(photos[0]);
      } else {
        this.albumPhotos = photos;
        this.photoAlbumVisible = true;
      }
    },
    openPhotoEdit(group) {
      this.photoEditGroup = group;
      this.photoEditUploadFiles = [];
      this.$nextTick(() => {
        this.$refs.photoEditUpload && this.$refs.photoEditUpload.clearFiles();
      });
      this.photoEditVisible = true;
    },
    deletePhotoInEdit(photo) {
      this.$confirm("确认删除该照片？", "提示", { type: "warning" }).then(() => {
        this.$apis.post("/admin/spot/stage/resource/delete", { id: photo.id }).then(res => {
          if (res.data.code == 200) {
            this.$message.success("删除成功");
            // 从当前编辑组中移除
            if (this.photoEditGroup) {
              this.photoEditGroup.photos = this.photoEditGroup.photos.filter(p => p.id !== photo.id);
            }
            this.loadStageDetail(this.currentStageId);
          } else {
            this.$message.error(res.data.msg || "删除失败");
          }
        });
      });
    },
    handlePhotoEditFilesChange(file, fileList) {
      this.photoEditUploadFiles = fileList.map(f => f.raw).filter(Boolean);
    },
    handlePhotoEditFilesRemove(file, fileList) {
      this.photoEditUploadFiles = fileList.map(f => f.raw).filter(Boolean);
    },
    confirmPhotoEditUpload() {
      if (!this.photoEditUploadFiles || this.photoEditUploadFiles.length === 0) {
        this.$message.error("请选择照片");
        return;
      }
      if (!this.photoEditGroup) {
        this.$message.error("未选择拍照点");
        return;
      }
      const currentCount = this.photoEditGroup.photos.filter(p => p.url && String(p.url).trim() !== '').length;
      if (currentCount + this.photoEditUploadFiles.length > 2) {
        this.$message.warning(`该拍照点最多上传2张照片，当前已有 ${currentCount} 张，本次选择了 ${this.photoEditUploadFiles.length} 张`);
        return;
      }

      const uploadOne = (file) => {
        const formData = new FormData();
        formData.append("stageId", this.currentStageId);
        if (this.taskId) formData.append("taskId", this.taskId);
        formData.append("type", "PHOTO");
        formData.append("longitude", parseFloat(this.photoEditGroup.longitude).toString());
        formData.append("latitude", parseFloat(this.photoEditGroup.latitude).toString());
        formData.append("file", file);
        return this.$apis.post("/admin/spot/stage/resource/upload", formData, {
          headers: {}
        });
      };

      Promise.all(this.photoEditUploadFiles.map(uploadOne))
        .then(results => {
          const allSuccess = results.every(res => res.data.code == 200);
          if (allSuccess) {
            this.$message.success("照片上传成功");
            this.photoEditUploadFiles = [];
            this.$refs.photoEditUpload && this.$refs.photoEditUpload.clearFiles();
            this.loadStageDetail(this.currentStageId);
            this.photoEditVisible = false;
          } else {
            const failed = results.find(res => res.data.code != 200);
            this.$message.error(failed ? (failed.data.msg || "部分照片上传失败") : "上传失败");
          }
        })
        .catch(err => {
          console.error("[confirmPhotoEditUpload] error:", err);
          this.$message.error("上传失败：" + (err.message || "网络错误"));
        });
    },
    deletePhotoGroup(group) {
      const validCount = group.photos.filter(p => p.url && String(p.url).trim() !== '').length;
      this.$confirm("确认删除该拍照点及其 " + validCount + " 张照片？", "提示", { type: "warning" }).then(async () => {
        // 串行删除，避免后端并发判断竞态
        for (const photo of group.photos) {
          try {
            await this.$apis.post("/admin/spot/stage/resource/delete", { id: photo.id });
          } catch (e) {
            // 忽略单个删除失败，继续删除下一个
          }
        }
        this.$message.success("删除成功");
        this.loadStageDetail(this.currentStageId);
      });
    },
    downloadResource(item) {
      const url = this.getFileUrl(item.url);
      const a = document.createElement("a");
      a.href = url;
      a.download = item.name || "download";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    deleteResource(item) {
      this.$confirm("确认删除该资源？", "提示", { type: "warning" }).then(() => {
        this.$apis.post("/admin/spot/stage/resource/delete", { id: item.id }).then(res => {
          if (res.data.code == 200) {
            this.$message.success("删除成功");
            this.loadStageDetail(this.currentStageId);
          } else {
            this.$message.error(res.data.msg || "删除失败");
          }
        });
      });
    },
    getFileUrl(path) {
      if (!path) return "";
      if (path.startsWith("http")) return path;
      // 相对路径，拼接后端 API 地址（生产环境前后端分离，文件存在后端服务器上）
      const base = config.baseUrl();
      const normalizedPath = path.replace(/\\/g, "/");
      return base + normalizedPath;
    },

    // 阶段管理
    addStage() {
      this.newStageOrder = 1;
      this.addStageVisible = true;
    },
    confirmAddStage() {
      if (!this.spotId || !this.taskInfo.year) {
        this.$message.error("缺少必要参数");
        return;
      }
      this.$apis.post("/admin/spot/stage/add", {
        spotId: this.spotId,
        year: this.taskInfo.year,
        stageOrder: this.newStageOrder
      }).then(res => {
        if (res.data.code == 200) {
          this.$message.success("添加成功");
          this.addStageVisible = false;
          this.loadStages();
        } else {
          this.$message.error(res.data.msg || "添加失败");
        }
      });
    },
    finishStage() {
      if (!this.currentStageId) return;
      this.$confirm("确认将该阶段标记为已完结？", "提示", { type: "warning" }).then(() => {
        this.$apis.post("/admin/spot/stage/finish", { id: this.currentStageId }).then(res => {
          if (res.data.code == 200) {
            this.$message.success("操作成功");
            this.loadStages();
          } else {
            this.$message.error(res.data.msg || "操作失败");
          }
        });
      });
    },

    // 数据保存（所有监测数据统一保存到阶段级别）
    saveAllData() {
      const promises = [];
      if (this.currentStageId) {
        const stageParams = { stageId: this.currentStageId };
        if (this.monitorData.vegetationCoverage != null) stageParams.vegetationCoverage = this.monitorData.vegetationCoverage;
        if (this.monitorData.vegetationSurvivalRate != null) stageParams.vegetationSurvivalRate = this.monitorData.vegetationSurvivalRate;
        if (this.monitorData.vegetationSurvivalCount != null) stageParams.vegetationSurvivalCount = this.monitorData.vegetationSurvivalCount;
        if (this.monitorData.soilQualityRate != null) stageParams.soilQualityRate = this.monitorData.soilQualityRate;
        if (this.monitorData.waterQualityRate != null) stageParams.waterQualityRate = this.monitorData.waterQualityRate;
        if (this.monitorData.repairArea != null) stageParams.repairArea = this.monitorData.repairArea;
        promises.push(this.$apis.post("/admin/spot/stage/data/save", stageParams));
      }
      Promise.all(promises).then(() => {
        this.$message.success("数据保存成功");
        this.originalMonitorData = JSON.parse(JSON.stringify(this.monitorData));
      }).catch(err => {
        this.$message.error("保存失败");
        console.error("saveAllData error", err);
      });
    },
    useCalculatedCoverage() {
      this.monitorData.vegetationCoverage = parseFloat(this.coveragePercent);
    },

    // 从图斑矢量计算面积（兜底用）
    calcSpotAreaFromVectors() {
      const spotPolys = this.spotVectors.filter(v => v.type === "area").map(v => v.coordinates);
      if (spotPolys.length === 0) return 0;
      let totalArea = 0;
      spotPolys.forEach(poly => {
        totalArea += this.calcPolygonArea(poly);
      });
      return totalArea;
    },
    // 计算图斑包围盒
    getSpotBbox() {
      if (!this.spotVectors || this.spotVectors.length === 0) return null;
      let minLon = Infinity, maxLon = -Infinity, minLat = Infinity, maxLat = -Infinity;
      this.spotVectors.forEach(v => {
        if (!v.coordinates) return;
        const coords = Array.isArray(v.coordinates[0]) ? v.coordinates : [v.coordinates];
        coords.forEach(c => {
          const lon = parseFloat(c[0]);
          const lat = parseFloat(c[1]);
          if (!isNaN(lon)) { minLon = Math.min(minLon, lon); maxLon = Math.max(maxLon, lon); }
          if (!isNaN(lat)) { minLat = Math.min(minLat, lat); maxLat = Math.max(maxLat, lat); }
        });
      });
      if (minLon === Infinity) return null;
      return { minLon, maxLon, minLat, maxLat };
    },

    // 生成网格外框坐标（弧度）
    buildGridCoords(centerLon, centerLat, sizeM) {
      const R = 6371000;
      const cosLat = Math.cos(centerLat);
      const dLon = sizeM / (R * cosLat);
      const dLat = sizeM / R;
      const x0 = centerLon - dLon / 2;
      const y0 = centerLat - dLat / 2;
      const x1 = centerLon + dLon / 2;
      const y1 = centerLat + dLat / 2;
      return [
        [x0, y0],
        [x1, y0],
        [x1, y1],
        [x0, y1],
        [x0, y0]
      ];
    },

    // 生成以中心点为基准的单个网格KML（坐标为弧度）
    buildGridKml(centerLon, centerLat, sizeM, name) {
      const R = 6371000;
      const latFactor = R;
      const lonFactor = R * Math.cos(centerLat);
      const dLon = sizeM / lonFactor;
      const dLat = sizeM / latFactor;
      const x0 = centerLon - dLon / 2;
      const y0 = centerLat - dLat / 2;
      const x1 = centerLon + dLon / 2;
      const y1 = centerLat + dLat / 2;
      // KML坐标：lon,lat,0
      const coords = `${x0},${y0},0 ${x1},${y0},0 ${x1},${y1},0 ${x0},${y1},0 ${x0},${y0},0`;
      return `<?xml version="1.0" encoding="UTF-8"?>\n<kml xmlns="http://www.opengis.net/kml/2.2">\n  <Document>\n    <name>${name}</name>\n    <Placemark>\n      <name>${name}</name>\n      <Polygon>\n        <outerBoundaryIs>\n          <LinearRing>\n            <coordinates>${coords}</coordinates>\n          </LinearRing>\n        </outerBoundaryIs>\n      </Polygon>\n    </Placemark>\n  </Document>\n</kml>`;
    },

    // 下载KML
    downloadKml(content, filename) {
      const blob = new Blob([content], { type: "application/vnd.google-earth.kml+xml" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    },

    // 植被网格：进入选点模式
    generateGrid() {
      console.log("[generateGrid] clicked, current gridPickingMode:", this.gridPickingMode);
      if (this.gridPickingMode) {
        this.gridPickingMode = false;
        this.clearGridPreview();
        this.$message.info("已取消选点");
        return;
      }
      const bbox = this.getSpotBbox();
      if (!bbox) {
        this.$message.warning("未加载图斑范围，无法生成网格");
        return;
      }
      this.gridPickingMode = true;
      this.clearGridPreview();
      console.log("[generateGrid] entering picking mode, gridSize:", this.gridSize);
      this.$message({
        message: "请在图斑范围内点击以确认生成网格（点击空白处或再次点击按钮取消）",
        type: "warning",
        duration: 5000
      });
    },

    // 显示网格预览（绘制横竖线组成的网格）
    showGridPreview(centerLon, centerLat, sizeM) {
      console.log("[showGridPreview] called, center:", centerLon, centerLat, "sizeM:", sizeM);
      this.clearGridPreview();
      const R = 6371000;
      const cosLat = Math.cos(centerLat);
      const dLon = sizeM / (R * cosLat);
      const dLat = sizeM / R;
      const x0 = centerLon - dLon / 2;
      const y0 = centerLat - dLat / 2;
      const x1 = centerLon + dLon / 2;
      const y1 = centerLat + dLat / 2;

      // 网格密度：1m画1x1，3m画3x3，10m画5x5
      const gridCount = sizeM <= 3 ? Math.max(1, sizeM) : 5;
      const stepLon = dLon / gridCount;
      const stepLat = dLat / gridCount;

      const Core = window.Swqyun.Core;
      const lines = [];
      // 横线
      for (let i = 0; i <= gridCount; i++) {
        const y = y0 + i * stepLat;
        lines.push({
          positions: [
            Core.Cartesian3.fromRadians(x0, y, 0),
            Core.Cartesian3.fromRadians(x1, y, 0)
          ]
        });
      }
      // 竖线
      for (let i = 0; i <= gridCount; i++) {
        const x = x0 + i * stepLon;
        lines.push({
          positions: [
            Core.Cartesian3.fromRadians(x, y0, 0),
            Core.Cartesian3.fromRadians(x, y1, 0)
          ]
        });
      }

      if (this.$refs.map && this.$refs.map.addPreviewGrid) {
        console.log("[showGridPreview] calling addPreviewGrid with", lines.length, "lines");
        this.$refs.map.addPreviewGrid(lines);
      } else {
        console.warn("[showGridPreview] addPreviewGrid not available, map ref:", this.$refs.map);
      }
      // 自动飞到预览区域，小格子需要拉近才能看见
      if (this.$refs.map && this.$refs.map.flyToPosition) {
        const flyHeight = Math.max(20, sizeM * 10);
        this.$refs.map.flyToPosition(centerLon, centerLat, flyHeight);
      }
    },
    clearGridPreview() {
      if (this.$refs.map && this.$refs.map.clearPreviewPolygons) {
        this.$refs.map.clearPreviewPolygons();
      }
    },
    clearAllGrids() {
      this.$confirm("确定要清除所有网格吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.taskVectors = [];
        this.clearGridPreview();
        this.saveVectors();
        this.$message.success("所有网格已清除");
      }).catch(() => {});
    },

    // 地图点击：若在选点模式则生成网格KML并保存到服务器
    async onMapClick(e) {
      console.log("[onMapClick] triggered, gridPickingMode:", this.gridPickingMode, "event:", e);
      if (!this.gridPickingMode) return;
      this.gridPickingMode = false;
      const lon = parseFloat(e.longitude);
      const lat = parseFloat(e.latitude);
      if (isNaN(lon) || isNaN(lat)) {
        this.$message.warning("获取坐标失败");
        return;
      }
      // 将度转换为弧度（bbox 和 buildGridKml 都使用弧度坐标）
      const lonRad = lon * Math.PI / 180;
      const latRad = lat * Math.PI / 180;
      const bbox = this.getSpotBbox();
      if (!bbox) {
        this.$message.warning("图斑范围未加载，无法生成网格");
        return;
      }
      if (lonRad < bbox.minLon || lonRad > bbox.maxLon || latRad < bbox.minLat || latRad > bbox.maxLat) {
        this.$message.warning("请点击在图斑范围内");
        return;
      }
      // 显示预览（使用用户选择的网格尺寸）
      const previewSize = parseInt(this.gridSize) || 3;
      this.showGridPreview(lonRad, latRad, previewSize);

      // 将预览网格添加到 taskVectors 持久化保存（刷新后仍能显示）
      const gridCoords = this.buildGridCoords(lonRad, latRad, previewSize);
      this.taskVectors.push({
        id: `grid-${Date.now()}`,
        type: "area",
        coordinates: gridCoords,
        area: this.calcPolygonArea(gridCoords)
      });
      this.saveVectors();

      const sizes = [1, 3, 10];
      const spotName = (this.taskInfo && this.taskInfo.spotName) || "图斑";
      let savedCount = 0;
      for (const sizeM of sizes) {
        const kml = this.buildGridKml(lonRad, latRad, sizeM, `${spotName}_植被网格_${sizeM}x${sizeM}m`);
        try {
          const res = await this.$apis.post("/admin/spotTask/saveKml", {
            filename: `${spotName}_植被网格_${sizeM}x${sizeM}m.kml`,
            content: kml
          });
          if (res.data && res.data.code == 200) {
            savedCount++;
          }
        } catch (err) {
          console.error("saveKml error", err);
        }
      }
      if (savedCount === 3) {
        this.$message.success("3种植被网格KML已保存到项目目录");
      } else {
        this.$message.warning(`KML保存完成，成功 ${savedCount}/3`);
      }
    },
    importKml() {
      const input = document.createElement("input");
      input.type = "file";
      input.accept = ".kml";
      input.onchange = e => {
        const file = e.target.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onload = evt => {
          try {
            const text = evt.target.result;
            const parser = new DOMParser();
            const xml = parser.parseFromString(text, "text/xml");
            const coords = [];
            const lines = xml.querySelectorAll("LineString coordinates, Polygon coordinates");
            lines.forEach(node => {
              const val = node.textContent.trim();
              if (!val) return;
              const points = val.split(/\s+/).map(c => {
                const parts = c.split(",");
                return [parseFloat(parts[0]), parseFloat(parts[1])];
              });
              if (points.length > 0) coords.push(points);
            });
            if (coords.length === 0) {
              this.$message.warning("KML 中未找到线或面数据");
              return;
            }
            let centerLon = 0, centerLat = 0, pointCount = 0;
            coords.forEach((c, idx) => {
              const isPolygon = c.length > 2 && JSON.stringify(c[0]) === JSON.stringify(c[c.length - 1]);
              this.taskVectors.push({
                id: `kml-${idx}-${Date.now()}`,
                type: isPolygon ? "area" : "line",
                coordinates: c,
                area: isPolygon ? this.calcPolygonArea(c) : 0
              });
              // 计算中心点用于 flyTo
              c.forEach(pt => {
                centerLon += pt[0];
                centerLat += pt[1];
                pointCount++;
              });
            });
            this.saveVectors();
            this.$message.success(`KML 导入成功，共 ${coords.length} 个矢量`);
            // 自动飞到导入区域（小尺寸格子需要拉近才能看见）
            if (pointCount > 0 && this.$refs.map && this.$refs.map.flyToPosition) {
              const avgLon = centerLon / pointCount;
              const avgLat = centerLat / pointCount;
              // 根据格子大小估算合适的相机高度：1m格子用20m高度，10m格子用50m高度
              const estimatedSize = Math.sqrt(this.taskVectors[this.taskVectors.length - 1].area || 100);
              const flyHeight = Math.max(15, Math.min(100, estimatedSize * 15));
              this.$nextTick(() => {
                this.$refs.map.flyToPosition(avgLon, avgLat, flyHeight);
              });
            }
          } catch (err) {
            this.$message.error("KML 解析失败");
          }
        };
        reader.readAsText(file);
      };
      input.click();
    },

    // 辅助
    formatCoord(lon, lat) {
      if (lon == null || lat == null) return "-";
      const lonStr = parseFloat(lon).toFixed(6);
      const latStr = parseFloat(lat).toFixed(6);
      return `${lonStr}°, ${latStr}°`;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/spotMonitorDetail.vue